import React from 'react';
import ReactSelect from '../../../common/components/UI/Select/ReactSelect';

// eslint-disable-next-line no-unused-vars
import { getRequestTypeList } from '../../Enums/Helpers/LabellingHelper';

/**
 * @param {ReturnType<typeof getRequestTypeList>} list
 * @param {number} id
 * @param {string} key
 * @returns {string}
 */
export const findItem = (list, id, key) => {
    if (list.length > 0) {
        let auxFind = list.find(item => item[key] === id)
        return typeof auxFind === 'undefined' ? '' : auxFind
    }
    return ''
}
export const generateInputs = (labelTypo, placeholder, value, list, target, disabled = false, error = false, note = '', handleChange) => (
    <ReactSelect
        labelText={labelTypo}
        placeholder={placeholder}
        value={value}
        options={list}
        onChange={handleChange}
        target={target}
        isDisabled={disabled}
        error={error}
        note={note}
    />
)
